/**
 * Minimal class-name joiner. No dependency, no variant engine — the design values
 * are transcribed literally per docs/01, so there is nothing to compute.
 */
export function cx(...parts: ReadonlyArray<string | false | null | undefined>): string {
  return parts.filter((p): p is string => typeof p === 'string' && p.length > 0).join(' ');
}
